import React from 'react'
import { object, func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Button } from '../../Button'

const StyledLink = styled(Button)`
  background: #da1b1b;
  padding: 8;
  borderradius: 3;
  color: #fff;
  display: 'block';
  text-decoration: underline;
`

const StyledWrapper = styled.div`
  margin-bottom: 0.875rem;
`

export function DuplicateEmail({ onExit, errors }) {
  if (!errors) return null
  if (!errors.email) return null
  if (errors.email !== 'has already been taken') return null

  return (
    <StyledWrapper>
      <FormattedMessage
        id='Authentication.Login.DuplicateEmail'
        defaultMessage='We noticed there is another account already that uses same email to login. Did you want to sign in with the other account instead?'
        description='The message text describing a duplicate email error.'
      >
        {(formattedText) => (
          <StyledLink size='small' onClick={onExit}>
            {formattedText}
          </StyledLink>
        )}
      </FormattedMessage>
    </StyledWrapper>
  )
}

DuplicateEmail.propTypes = {
  errors: object,
  onExit: func,
}
